var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8848 3.11522C12.3978 1.62826 9.98696 1.62826 8.5 3.11522L6.40851 5.20672C7.2599 7.72969 9.1501 9.76479 11.5759 10.8089L13.8848 8.5C15.3717 7.01303 15.3717 4.60219 13.8848 3.11522Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4464 11.9383C8.10675 10.776 6.25046 8.79801 5.24422 6.37097L3.11522 8.49997C1.62826 9.98693 1.62826 12.3978 3.11522 13.8848C4.60219 15.3717 7.01303 15.3717 8.5 13.8848L10.4464 11.9383Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9654 12.9739C19.1358 12.3618 18.1101 12 17 12C14.2386 12 12 14.2386 12 17C12 18.1101 12.3618 19.1358 12.9739 19.9654L19.9654 12.9739Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0346 21.0261C14.8642 21.6382 15.8899 22 17 22C19.7614 22 22 19.7614 22 17C22 15.8899 21.6382 14.8642 21.0261 14.0346L14.0346 21.0261Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineAlt);
export default __webpack_public_path__ + "static/media/medicine-alt.e69ae09d7b91554d3131e587f5363218.svg";
export { ForwardRef as ReactComponent };